module.exports = __webpack_public_path__ + "img/59_22.fd1d19e0.png";